@if (isActivate()) {
<p>
  {{ message() }}
</p>
} @else {
<app-register-form
  (resetPasswordEvent)="resetPassword($event)"
  [loading]="loading"
  [isResetPassword]="true"
/>
}

<p-toast />
